import request from '@/axios/request.js'

import { requestConfig } from '@/api/index.js'

export const uploadURL = `${requestConfig.url}/system/upload/upload`
export const uploads = `${requestConfig.url}/system/upload/uploadList`
// export function uploadData () {
//   return request({
//     url: '/api/api/upload',
//     method: ''
//   })
// }
// 获取城市列表
export function getCityData () {
  return request({
    url: '/mall/city_list',
    method: 'get'
  })
}

// 获取地址列表
export function getAddressData () {
  return request({
    url: '/mall/address/list',
    method: 'get'
  })
}

// 设置默认地址
export function setDefaultAddress (data) {
  return request({
    url: '/mall/address/default/set',
    method: 'post',
    data
  })
}

// 编辑地址
export function editAddressData (data) {
  return request({
    url: '/mall/address/edit',
    method: 'post',
    data
  })
}

// 删除地址
export function deleteAddress (data) {
  return request({
    url: '/mall/address/del',
    method: 'post',
    data
  })
}

// 获取收藏、足迹
export function getCollectData (params) {
  return request({
    url: '/mall/collect/user',
    method: 'get',
    params
  })
}

// 添加收藏、足迹
export function addCollection (data) {
  return request({
    url: '/mall/collect/add',
    method: 'post',
    data
  })
}

// 删除收藏、足迹
export function deleteCollection (data) {
  return request({
    url: '/mall/collect/del',
    method: 'post',
    data
  })
}

// 批量删除足迹
export function deleteAllCollection (data) {
  return request({
    url: '/mall/collect/delFoot',
    method: 'delete',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js